import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Map as MapIcon, Route, Clock, Info } from "lucide-react";

const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const RouteMap = ({ von, vonPlz = "", nach, nachPlz = "" }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!von || !nach) return;
    api.get("/geo/route", { params: { von, von_plz: vonPlz, nach, nach_plz: nachPlz } })
      .then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, [von, vonPlz, nach, nachPlz]);

  if (!von || !nach) return null;
  const origin = encodeURIComponent(`${vonPlz} ${von}, Deutschland`);
  const dest = encodeURIComponent(`${nachPlz} ${nach}, Deutschland`);
  const hours = info?.minutes ? `${Math.floor(info.minutes / 60)} Std. ${info.minutes % 60} Min.` : null;

  return (
    <div className="eb-card overflow-hidden" data-testid="route-map">
      <div className="flex flex-wrap items-center gap-4 px-5 py-3 text-sm border-b border-slate-800">
        <span className="flex items-center gap-1.5 text-slate-300 font-head font-semibold"><MapIcon className="w-4 h-4 text-[#FF5A1F]" /> {von} → {nach}</span>
        {info?.km != null && <span className="flex items-center gap-1.5 text-slate-400"><Route className="w-4 h-4" /> <span className="mono" data-testid="route-distance">{info.km} km</span></span>}
        {hours && <span className="flex items-center gap-1.5 text-slate-400"><Clock className="w-4 h-4" /> {hours}</span>}
        <span className={`eb-badge ml-auto ${info?.source === "google" ? "bg-emerald-500/15 text-emerald-400" : "bg-slate-700/40 text-slate-400"}`} data-testid="route-source">
          {info?.source === "google" ? "Google Maps" : "Schätzung"}
        </span>
      </div>
      {KEY ? (
        <iframe title="Routenkarte" className="w-full h-72 block" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/directions?key=${KEY}&origin=${origin}&destination=${dest}&mode=driving&language=de`} />
      ) : (
        <div className="px-5 py-4 text-xs text-slate-500 flex items-center gap-2" data-testid="route-map-fallback">
          <Info className="w-3.5 h-3.5" /> Kartenansicht erscheint, sobald der Google-Maps-Key hinterlegt ist. Entfernung basiert auf Städte-/PLZ-Schätzung.
        </div>
      )}
    </div>
  );
};
